import { ReactNode } from 'react';

import useAutoNavigator from './vm';

export interface AutoNavigatorProps {
  children: ReactNode;
}

const AutoNavigator = ({ children }: AutoNavigatorProps) => {
  useAutoNavigator();
  return <>{children}</>;
};

export default AutoNavigator;
